import camelcaseKeys from 'camelcase-keys'
export class SlotCapacity {
  constructor (params = {}) {
    const { reservationMethod, date, hour, currentCapacity } = params ? camelcaseKeys(params) : {}
    this.reservationMethod = reservationMethod || null
    this.date = date || null
    this.hour = hour || null
    this.currentCapacity = currentCapacity || null
  }
}
